import { render, staticRenderFns } from "./ThemeProvider.vue?vue&type=template&id=e3ed3f9a&"
import script from "./ThemeProvider.vue?vue&type=script&lang=js&"
export * from "./ThemeProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ThemeProvider.vue"
export default component.exports